.label {
    align-items: center;
    color: var(--black);
    display: flex;
    font: var(--font-eyebrow-14);
    gap: var(--spacer-8);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.select {
    appearance: none;
    background-color: transparent;
    border: none;
    color: var(--black);
    font: var(--font-p-18);
    cursor: pointer;
    padding-right: var(--spacer-16);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%230c0c0c' stroke-width='1.5' fill='none'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right center;
    background-size: 12px 8px;
}
